<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import { useData } from "$lib/state/data.svelte.js";

  const data = useData();
</script>

{#if data.currentMetadata?.solutions_brief_link || data.currentMetadata?.linked_metric}
  <div class="metric-links">
    {#if data.currentMetadata?.linked_metric}
      <button
        class="metric-link"
        onclick={() => {
          if (data.currentMetadata?.linked_metric) {
            data.currentMetric = /** @type {import("$lib/utils/types.d.ts").Metric} */ (
              data.currentMetadata.linked_metric
            );
          }
        }}
      >
        {data.labels.metric_link_label.replace(
          "[label]",
          data.getMetricLabel(data.currentMetadata.linked_metric)
        )}
      </button>
    {/if}
    {#if data.currentMetadata?.solutions_brief_link}
      <div class="solutions-link">
        <a
          href={data.currentMetadata.solutions_brief_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.labels.solution_brief_link_label}
        </a>
      </div>
    {/if}
  </div>
{/if}

<style>
  .metric-links {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
    font-size: var(--font-size-normal, 18px);
    font-weight: var(--font-weight-bold);
    padding-bottom: var(--spacing-8);
  }
  .metric-links .metric-link {
    background: none;
    border: none;
    padding: 0;
    color: var(--color-blue);
    cursor: pointer;
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    line-height: inherit;
    text-align: left;
  }
  .metric-links .metric-link:hover {
    color: var(--color-blue, #1696d2);
  }
  .metric-links a {
    color: var(--color-blue-shade-darkest, #062635);
    text-decoration: underline !important;
  }
  .metric-links a:hover {
    color: var(--color-blue, #1696d2);
  }
  @media (min-width: 1024px) {
    .metric-links {
      gap: var(--spacing-2);
    }
  }
</style>
